import { WorkerOptions } from "./types";
import { ParticipantEventHandler } from "../../modules/cbm/Cbm";

export const applyDefaultOptions = <T extends WorkerOptions>(options?: T): T => {
    const defaultOptions: WorkerOptions = {
        eventHandlerClass: ParticipantEventHandler
    };

    return { ...defaultOptions, ...options } as T;
};
